import React from 'react';

import { RootMenuItem } from '../../types';

import { ModulesScrollbar } from 'app/design-system/components/Scrollbar';

import { useLeftMenuStateAPI } from '../../hooks/left-menu-state-api';
import Item from './Item';

import styles from '../../styles/LeftMenu.module.scss';

type RootMenuItemsProps = {
  list: RootMenuItem[];
};

const RootMenuItems: React.FC<RootMenuItemsProps> = ({ list }) => {
  const { collapsed } = useLeftMenuStateAPI();

  return (
    <ModulesScrollbar>
      <ul className={styles.rootMenuItems}>
        {list.map((entry) => (
          <Item key={entry.key}
                entry={entry}
                showHint={collapsed} />
        ))}
      </ul>
    </ModulesScrollbar>
  );
};

export default RootMenuItems;
